module.exports = __webpack_public_path__ + "static/img/05.b0c6c3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-cgM/05.jpg
// module id = nrOd
// module chunks = 1